/* src/app/features/purchase-requests/supplier-selection/supplier-selection.component.css */
* {
  color: #4a5c60;
}
.container {
  width: 100% !important;
}
po-table {
  width: 100%;
}
::ng-deep .po-checkbox {
  font-weight: bold;
}
.button-load {
  margin: 0 auto;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 40%;
}
.button {
  margin-left: 10px;
}
.buttonsSubmit {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  height: 46px;
}
.footer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: solid 2px rgba(128, 128, 128, 0.176);
  flex-wrap: nowrap;
}
/*# sourceMappingURL=supplier-selection.component.css.map */
